<template lang="pug">
oarepo-item(:isolated="true" collectionCode="works" :itemId="workId" ref="oarepo")
  template(v-slot:default="{collection, item}")
    q-uploader.full-width(flat ref="uploader" :editable="true"
      auto-upload :url="uploadUrl" @uploaded="fileUploaded"
      @start="fileUploading" accept=".jpg,image/*,application/pdf")
      template(v-slot:list)
        q-markup-table.full-width.tbl(flat separator="none")
          tbody
            kv(label="Typ práce"
              :item="item.metadata" path="workType" type="taxonomy"
              :editor-options="{taxonomy: 'work-type', rules: [$rules.required('Nastavte prosím typ práce')]}"
              :edit="edit")
            kv(label="Restauroval/a" :item="item.metadata" path="creator" :edit="edit" type="text-input")
            kv(label="Vedoucí práce" :item="item.metadata" path="supervisor" type="supervisor" :edit="edit")
            kv(label="Období restaurování předmětu" :item="item.metadata" path="restorationPeriod" type="datePeriod" :edit="edit")
            kv(label="Metody průzkumu" :item="item.metadata" path="examinationMethods" type="taxonomy-array"
              :editor-options="{taxonomy: 'examination-methods'}" :edit="edit")
            kv(label="Metody restaurování"
              :item="item.metadata" path="restorationMethods" type="taxonomy-array"
              :editor-options="{taxonomy: 'restoration-technology'}" :edit="edit")
            kv(label="Restaurátorský zásah/záměr"
              :editor-options="{ rules: [$rules.maxWords(200, 'Text nesmí být delší jak 200 slov. Celková délka textu nesmí přesáhnout 5000 znaků.')] }"
              :item="item.metadata" path="abstract" type="multilingual-html" :edit="edit")
            tr.q-pb-md()
              th.text-left.key
                .text-subtitle1.text-weight-medium.text-black Dokumenty
              td.text-left.q-pb-md
                q-list.dedent-md
                  q-item(clickable v-for="file in (item.metadata._files || [])" :key="file.key" v-if="!isImage(file)")
                    q-item-section(thumbnail)
                      q-icon.thumbnail(:name="fileIcon(file)")
                    q-item-section
                      .row.full-width
                        .column.col
                          q-item-label(lines="2") {{ file.key | truncate(45) }}
                          q-item-label(caption) ({{ Number(file.size/1024).toFixed(0) }} kb)
                        div
                          q-btn-group(outline)
                            q-btn.float-right(outline @click="starFile(file)" v-if="isImage(file)" icon="star_border" color="primary" size="sm")
                              q-tooltip(content-class="bg-accent" anchor="top middle" self="bottom middle")
                                .text-caption Zobrazit v náhledu předmětu
                            //- TODO: make this nicer
                            q-btn.float-right(outline  icon="cloud_download" color="accent" size="sm"
                              @click="downloadAttachment(file)")
                              q-tooltip(content-class="bg-accent" anchor="top middle" self="bottom middle")
                                .text-caption Stáhnout přílohu
                            q-btn.float-right(outline @click="deleteFile(file)" icon="delete" color="negative" size="sm")
                              q-tooltip(content-class="bg-accent" anchor="top middle" self="bottom middle")
                                .text-caption Smazat přílohu
                q-btn.dedent-md(outline icon="add" color="secondary" @click.native="pickFiles" :loading="uploading") Přidat PDF a další přílohy
            tr.q-pb-md()
              th.text-left.key
                .text-subtitle1.text-weight-medium.text-black Vybrané obrázky do galerie
              td.text-left.q-pb-md
                gallery(:images='selectedImages(item)'
                  :editable="true" :container-url="uploadUrl")
                div.q-mt-md.q-mb-sm.dedent-md(v-if="!selectedImages(item).length && allImages(item).length")
                  | Zatím není vybrán žádný obrázek
                q-btn.dedent-md(outline icon="image" color="secondary" @click="selectImages(item, unselectedImages(item))"
                  v-if="unselectedImages(item).length") &nbsp;Vybrat obrázky z příloh ({{ unselectedImages(item).length }} nevybraných obrázků)
</template>
<style lang="stylus">
</style>
<script>
import { lookup } from 'mime-types'
import { Component, Vue } from 'vue-property-decorator'
import KVPair from '../../KVPair.vue'
import InPlace from 'components/edit/InPlace.vue'
import convertMime from 'mimetype-to-fontawesome'
import SelectImagesDialog from './SelectImagesDialog.vue'
import Gallery from 'components/images/Gallery.vue'
import FileSaver from 'file-saver'

export default @Component({
  props: {
    workId: String
  },
  components: {
    'kv': KVPair,
    'in-place': InPlace,
    'gallery': Gallery
  }
})
class WorkCard extends Vue {
  edit = false
  uploading = false

  pickFiles () {
    this.$refs.uploader.pickFiles()
  }

  get uploadUrl () {
    return `${this.$refs.oarepo.store.itemRestUrl}/attachments`
  }

  downloadAttachment (file) {
    // TODO: possibly move this url to a better place
    let dlPath = `/api/files/${file.bucket}/${file.key}`
    FileSaver.saveAs(dlPath, file.key)
  }

  fileData (file) {
    return this.$restorationWork.getAttachmentDataUrl(file)
  }

  iiifImage (file) {
    return `${this.$restorationWork.getAttachmentIIIFUrl(file)}full/400,/0/default.png`
  }

  isImage (file) {
    if (this.fileMime(file).startsWith('image/')) {
      return true
    }
    return false
  }

  selectedImages (item) {
    return this.allImages(item).filter(x => x.selected)
  }

  unselectedImages (item) {
    return this.allImages(item).filter(x => !x.selected)
  }

  allImages (item) {
    return (item.metadata._files || []).filter(x => this.isImage(x))
  }

  fileMime (file) {
    if (file.mime_type) {
      return file.mime_type
    }
    let rext = /(?:\.([^.]+))?$/
    let ext = rext.exec(file.key)[1]
    return lookup(ext) || 'application/binary'
  }

  fileIcon (file) {
    return convertMime(this.fileMime(file) || 'application/pdf', { prefix: 'far fa-' })
  }

  starFile (file) {
  }

  deleteFile (file) {
    this.$q.dialog({
      title: 'Potvrzení smazání',
      message: 'Opravdu chcete smazat tento soubor? Akci není možno vzít zpět!',
      cancel: true,
      persistent: true
    }).onOk(() => {
      this.$restorationWork.deleteAttachment({ work: this.$refs.oarepo.store.item, attachment: file }).then((resp) => {
        this.$refs.oarepo.store.reload()
      }).catch((err) => {
        this.notify$({ message: err })
      })
    })
  }

  selectImages (item, unselectedImages) {
    unselectedImages.forEach(x => {
      x.selected = !!x.selected
    })
    if (unselectedImages.length === 0) {
      return
    }
    this.$q.dialog({
      component: SelectImagesDialog,
      images: unselectedImages,
      storeSelection: img => this.storeSelection(item, img)
    }).onDismiss((images) => {
      this.$refs.oarepo.store.reload().then(() => {
        this.oarepo$.collectionItemModule.reload()
      })
    })
  }

  async storeSelection (item, img) {
    this.$q.dialog({
      title: 'Nastavení popisku',
      message: 'Popisek obrázku',
      prompt: {
        model: img.caption || ''
      },
      cancel: true,
      persistent: true
    }).onOk(data => {
      if (!data) {
        img.selected = false
        this.notify$({ message: 'Je nutno vyplnit popisek' })
        return
      }
      img.caption = data
      this.$restorationWork.selectImg({ itemUrl: item.links.self, img: img })
      this.notify$({ message: 'Uloženo' })
      this.$restorationObject.setDirty(true)
    }).onCancel(data => {
      img.selected = false
    })
  }

  fileUploaded () {
    this.$refs.oarepo.store.reload().then(() => {
      this.notify$({ message: 'Příloha uložena' })
      this.uploading = false
      const item = this.$refs.oarepo.store.item
      this.selectImages(item, this.allImages(item))
    })
  }

  fileUploading () {
    this.uploading = true
  }
}
</script>
<style lang="stylus" scoped>
>>> .q-uploader__header
  display none

>>> .q-uploader
  max-height fit-content

.thumbnail
  max-height 150px
  max-width 150px
  height 40px
  min-width 40px

.imageholder
  display inline-block
  text-wrap normal

.q-markup-table.tbl
  th.key
    vertical-align top

  td
    margin-bottom 16px
    padding-bottom 16px
</style>
